import {useHistory, useLocation} from "react-router-dom";

export default function useParamsGetter(...args) {
    const location = useLocation();
    const history = useHistory();

    const urlParams = new URLSearchParams(location.search);

    const getValue = () => {
        const res = []
        Array.from(args).forEach(x=>res.push(urlParams.get(x)))
        return res
    }
    // const setValue = (v = '') => {
    //     if (!v) {
    //         urlParams.delete(parameterName);
    //     } else if (urlParams.has(parameterName)) {
    //         urlParams.set(parameterName, v);
    //     } else {
    //         urlParams.append(parameterName, v);
    //     }
    //
    //     history.replace({
    //         search: decodeURIComponent(urlParams.toString()),
    //     });
    //
    //     return urlParams;
    // };

    return getValue();
}
